module.exports = __webpack_public_path__ + "media/images/payments/shopify-dark-3766a794da2c97aca82f8603774a3c3e.svg";